// Mirrors getApiUrl() in public/m.eagle/app/svc.js and service-worker.js: the legacy picks the API from the page hostname, so its token always belongs to that API.
const API_BY_HOST = [
	['localhost', 'https://apiv2.ecos.externis.net'],
	['m-dev', 'https://apiv2.ecos2.externis.net'],
	['m.ecos.externis.net', 'https://apiv2.ecos.externis.net'],
	['m.ecos2.externis.com', 'https://apiv2.ecos2.externis.com'],
];

export const resolveApiBaseUrl = (hostname, fallback = '') => API_BY_HOST.find(([key]) => hostname?.includes(key))?.[1] ?? fallback;
